var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('map-product',{attrs:{"data":_vm.node,"companyId":_vm.companyId,"productId":_vm.productId,"projectId":_vm.projectId,"read_only":_vm.read_only,"is_show":_vm.is_show}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }